import type { ICurrency } from 'store/fetchers/currencies'
import type { Periods } from 'pages/account/wallets/info/wallet.types'

import { IFormattedLoan } from '../../../../store/fetchers/loans/enum'
import { IFormattedEarning } from '../../../../store/fetchers/earnings/enum'

export interface ColumnsProps {
  columns: string[]
  loan?: IFormattedLoan
}

export interface CellProps {
  className?: string
  loan?: IFormattedLoan
}

export interface CurrencyCellProps extends CellProps {
  ticker: string
  network: string
}

export interface AmountCellProps extends CellProps {
  ticker: string
  network: string
  amount: string
  additionalAmount?: string
  isLoading?: boolean
  loan?: IFormattedLoan
}

export interface StatusCellProps extends CellProps {
  status: string
  id?: string
  createdAt?: string
  isLoans?: boolean
  loan?: IFormattedLoan
}

export interface ContainerProps extends ColumnsProps {
  onClick: () => void
  isInIncrease?: boolean
  loan?: IFormattedLoan
  saving?: IFormattedEarning
}

export enum SortingStates {
  NotSort = 0,
  AscendingOrder = 1,
  DescendingOrder = 2,
}

export interface ColumnHeaderCellProps {
  title: string
  onClick?: () => void
  onClearSort?: () => void
  isActive?: boolean
  sortingState?: SortingStates
  width?: number
  className?: string
}

export interface ChartCellProps {
  currency: ICurrency
  period: Periods
  className?: string
  color: string
}
